import { render, staticRenderFns } from "./new-field-detail.vue?vue&type=template&id=7202b748&scoped=true&"
import script from "./new-field-detail.vue?vue&type=script&lang=js&"
export * from "./new-field-detail.vue?vue&type=script&lang=js&"
import style0 from "./new-field-detail.vue?vue&type=style&index=0&id=7202b748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202b748",
  null
  
)

export default component.exports